<template>
    <div class="pos-r" v-bind:style="{width: width, height:height}">
        <div v-show="status==1"
             class="textC ys-info-color"
             v-bind:style="{width: width, height:height,lineHeight:height}">
            <div class="d-i-b verticalM">
                <!--<p style="line-height:1"><i class="ys-icon icon-chart-no-data"-->
                                            <!--style="margin-left:6px;color:rgba(154,188,238,0.25);font-size: 60px;"></i>-->
                <!--</p>-->
                 <p v-if="no == '1'" v-bind:style="{width: width, height:height,lineHeight:height, color: '#787878'}">暂无数据</p>
                <p v-if="no == '2'"><img style="width: 60%;vertical-align: middle;max-width: 200px;opacity:0.5; " src="../assets/img/nochart.png" alt=""></p>
            </div>
            <span style="display:none;">{{status}}</span>
        </div>
        <div v-show="status==2">
            <div v-bind:style="{width: width,height:height}">
                <div :id="'series-gauge-chart-'+id"
                     v-bind:style="{width: width,height:height}"
                     v-on:resize="handleResize($event)">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
<script>
    export default {
        name: 'series-gauge-chart',
        props: {
            id: {
                default: 0
            },
            name: {
                default: ""
            },
            width: {
                default: "100%"
            },
            height: {
                default: "200px"
            },
            x: {
                default: ""
            },
            y: {
                default:function () {
                    return []
                }
            },
            min: {             // 最小值
                default: 0
            },
            max: {             // 最大值
                default: 1.6
            },
            minline: {         // 最小警戒线
                default: 0
            },
            maxline: {         // 最大警戒线
                default: 0
            },
            unit: {
                default: ""
            },
            tipname: {
                default: ""
            },
            no:{
                default: '1'
            }
        },
        computed: {
            status: function () {
                if (this.x.length > 0) {
                    this.$nextTick(()=>{
                        this.initChart();
                    });
                    return 2
                } else {
                    return 1
                }
            },
        },
        data() {
            return {
                symbol: ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow']
            }
        },
        methods: {
            initChart() {
                let self = this;
                let repeat = setInterval(function () {
                    if (document.getElementById('series-gauge-chart-' + self.id)) {
                        self.setChart();
                        window.addEventListener('resize', self.handleResize)
                        var EleResize = {
                            _handleResize: function (e) {
                                var ele = e.target || e.srcElement;
                                var trigger = ele.__resizeTrigger__;
                                if (trigger) {
                                    var handlers = trigger.__z_resizeListeners;
                                    if (handlers) {
                                        var size = handlers.length;
                                        for (var i = 0; i < size; i++) {
                                            var h = handlers[i];
                                            var handler = h.handler;
                                            var context = h.context;
                                            handler.apply(context, [e]);
                                        }
                                    }
                                }
                            },
                            _removeHandler: function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    var size = handlers.length;
                                    for (var i = 0; i < size; i++) {
                                        var h = handlers[i];
                                        if (h.handler === handler && h.context === context) {
                                            handlers.splice(i, 1);
                                            return;
                                        }
                                    }
                                }
                            },
                            _createResizeTrigger: function (ele) {
                                var obj = document.createElement('object');
                                obj.setAttribute('style',
                                    'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
                                obj.onload = EleResize._handleObjectLoad;
                                obj.type = 'text/html';
                                ele.appendChild(obj);
                                obj.data = 'about:blank';
                                return obj;
                            },
                            _handleObjectLoad: function (evt) {
                                this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
                                this.contentDocument.defaultView.addEventListener('resize', EleResize._handleResize);
                            }
                        };
                        if (document.attachEvent) {//ie9-10
                            EleResize.on = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (!handlers) {
                                    handlers = [];
                                    ele.__z_resizeListeners = handlers;
                                    ele.__resizeTrigger__ = ele;
                                    ele.attachEvent('onresize', EleResize._handleResize);
                                }
                                handlers.push({
                                    handler: handler,
                                    context: context
                                });
                            };
                            EleResize.off = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    EleResize._removeHandler(ele, handler, context);
                                    if (handlers.length === 0) {
                                        ele.detachEvent('onresize', EleResize._handleResize);
                                        delete  ele.__z_resizeListeners;
                                    }
                                }
                            }
                        } else {
                            EleResize.on = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (!handlers) {
                                    handlers = [];
                                    ele.__z_resizeListeners = handlers;
                                    if (getComputedStyle(ele, null).position === 'static') {
                                        ele.style.position = 'relative';
                                    }
                                    var obj = EleResize._createResizeTrigger(ele);
                                    ele.__resizeTrigger__ = obj;
                                    obj.__resizeElement__ = ele;
                                }
                                handlers.push({
                                    handler: handler,
                                    context: context
                                });
                            };
                            EleResize.off = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    EleResize._removeHandler(ele, handler, context);
                                    if (handlers.length === 0) {
                                        var trigger = ele.__resizeTrigger__;
                                        if (trigger) {
                                            trigger.contentDocument.defaultView.removeEventListener('resize', EleResize._handleResize);
                                            ele.removeChild(trigger);
                                            delete ele.__resizeTrigger__;
                                        }
                                        delete  ele.__z_resizeListeners;
                                    }
                                }
                            }
                        }
                        var resizeDiv = document.getElementById('series-gauge-chart-' + self.id);
                        EleResize.on(resizeDiv, function () {
                            self.handleResize()
                        });
                        clearInterval(repeat)
                    }
                }, 300)
            },
            setChart() {
                let self = this, series = [];
                self.chart = this.$echarts.init(document.getElementById('series-gauge-chart-' + this.id));
                this.option = {
                    tooltip: {
                        trigger: 'item',
                    },
                    title: [
                        {
                            subtext: '{line|▲}{text|Min报警线}', 
                            offsetCenter: [0,0],
                            left:'0%',
                            bottom :10, 
                            subtextStyle:{
                                color: '#fff',
                                rich:{
                                    line:{
                                        color:'#74D9FF',
                                    },
                                    text:{
                                        padding: [0, 0, 0, 4]
                                    }
                                }
                            },
                        },
                        {
                            subtext: '{line|▲}{text|Max报警线}',
                            right:'0%',
                            bottom :10,
                            subtextStyle:{
                                color: '#fff',
                                rich:{
                                    line:{
                                        color:'#74D9FF',
                                    },
                                    text:{
                                        padding: [0, 0, 0, 4]
                                    }
                                }
                            },
                        }
                    ],
                    series: [
                        {
                            name: '水压',
                            type: 'gauge',
                            radius: '100%',
                            center: ["50%", '60%'],
                            startAngle: 180,
                            endAngle: 0,
                            z: 3,
                            min: this.min,
                            max: this.max,
                            splitNumber: 2,
                            splitLine : {    
                                length : 15,
                                lineStyle : { 
                                    width : 2
                                }
                            },
                            axisTick:{
                                show:true,
                                length:10,
                                splitNumber:8,
                            },
                            axisLabel:{
                                show:true,
                            },
                            pointer:{
                                length: '80%',
                                width:3,
                            },
                            itemStyle:{
                                color:'#019999',//#52F2B8
                                borderType:'dashed'
                            },
                            axisLine: {           
                                lineStyle: {        
                                    width: 15,
                                    shadowBlur: 0,
                                    color: [ 
                                        [this.minline/this.max, '#74D9FF'], //#f3ba26
                                        [this.maxline/this.max, '#5f5f5f'], //#52F2B8
                                        [1, '#5f5f5f']
                                    ]
                                } 
                            },
                            markPoint:{
                                label:{
                                    show:false,
                                },
                                data: [
                                    {
                                        name: '最小警戒线',
                                        symbol: 'triangle',
                                        symbolSize: 15,
                                        symbolRotate: 270,
                                        itemStyle:{
                                            color: '#74D9FF'
                                        },
                                        x: '10%', //相对容器的屏幕 x 坐标，单位像素。根据屏幕的变化需要手动计算值
                                        y: '27%'  //相对容器的屏幕 y 坐标，单位像素。根据屏幕的变化需要手动计算值
                                    },
                                    {
                                        name: '最大警戒线',
                                        symbol: 'triangle',
                                        symbolSize: 15,
                                        symbolRotate: -270,
                                        itemStyle:{
                                            color: '#74D9FF'
                                        },
                                        x: '91%',
                                        y: '27%'
                                    },
                                ]
                            },
                            detail:{
                                offsetCenter:[0,'27%'],
                                formatter : "{value}{score|Mpa}",
                                height:30,
                                fontSize:24,
                                rich : {
                                    score : {
                                        color : "#fff",
                                        fontFamily : "微软雅黑",
                                        fontSize : 14
                                    }
                                }
                            },
                            data: this.x
                        }
                    ]
                }; 
                self.chart.clear();
                setTimeout(() => {
                    self.chart.setOption(self.option);
                }, 0);
            },
            handleResize() {
                this.chart.resize();
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/series-gauge.vue